module.exports = __webpack_public_path__ + "img/bot-avatar.80944d7d.png";